import controller from './stLocation.controller';
import template from './stLocation.html';
import templateView from './stLocation-view.html';

let stLocationComponent = {
    restrict: 'E',
    bindings: {
        transfer: '=',
        type: '@',
        direction: '@'
    },
    template: function ($element, $attrs) {
        'ngInject';
        return $attrs.editable == "true" ? template : templateView;
    },
    controller,
    controllerAs: 'vm'
};

export default stLocationComponent;



// WEBPACK FOOTER //
// ./client/app/common/stLocation/stLocation.component.js